import {
  Heart,
  HeartPulse,
  type LucideIcon,
  PawPrint,
  Plane,
  Scale,
  Scissors,
  ShowerHead,
  Stethoscope,
  Syringe,
  TestTube,
} from 'lucide-react'

import {
  APPOINTMENT_TYPES,
  type AppointmentTypeId,
  requireAppointmentType,
} from '@snootsvet/shared/portal'

export type MemberVisibleAppointmentTypeId = Extract<
  (typeof APPOINTMENT_TYPES)[number],
  { memberBooking: 'self-service' | 'contact-team' }
>['id']

export const MEMBER_VISIBLE_APPOINTMENT_TYPE_IDS = APPOINTMENT_TYPES.filter(
  (type) => type.memberBooking !== 'hidden'
).map((type) => type.id) as MemberVisibleAppointmentTypeId[]

export const APPOINTMENT_TYPE_ICONS = {
  'first-visit': PawPrint,
  'routine-checkup': Stethoscope,
  vaccinations: Syringe,
  'injectable-treatments': Syringe,
  'weight-check-preventatives': Scale,
  'anal-gland-expression': ShowerHead,
  'nail-clipping': Scissors,
  'post-op-consultation': Stethoscope,
  'wellness-screen': HeartPulse,
  bloodwork: TestTube,
  'animal-health-certificate': Plane,
  euthanasia: Heart,
} satisfies Record<MemberVisibleAppointmentTypeId, LucideIcon>

/** Returns the member-facing presentation for an appointment type. */
export function getAppointmentTypeConfig(id: AppointmentTypeId): {
  label: string
  icon: LucideIcon
} {
  const appointmentType = requireAppointmentType(id)
  const label = appointmentType.memberLabel ?? appointmentType.name

  return {
    label,
    icon: APPOINTMENT_TYPE_ICONS[id as MemberVisibleAppointmentTypeId] ?? PawPrint,
  }
}
